// src/lib/layout.js
//
// Shared layout constants for the Inventory screens.
//
// DESKTOP_COLUMN was a magic 1100 living independently in RequestMaterialsPage.js
// and -- copied from it at #282 -- in InventoryActionCatalog.js, which recorded the
// copy in a source comment rather than sharing the value. #356 would have made it a
// third instance. That is #252's shape exactly (the four-branch list, hardcoded
// independently in 13 files), so the number is extracted here before it spreads
// further rather than after.
//
// 1100px is the content measure every Inventory screen shares. Changing it changes
// all of them together, which is the entire point of it living here.
export const DESKTOP_COLUMN = 1100;

// The viewport width below which the Inventory screens use their phone layout.
// Matches the window.innerWidth < 768 checks already live in
// InventoryActionCatalog.js and PrinterRegistryPage.js.
//
// Read it with a useState + resize listener, never a bare window.innerWidth read at
// render time -- that was #64, and #164 found the same gap a second time. A plain
// read is correct exactly once, on mount, and then silently wrong for the rest of
// the session.
export const MOBILE_BREAKPOINT = 768;

// #370, Session 78j — the third width tier. Below MOBILE_BREAKPOINT is the phone
// layout; between the two is the bounded single column #356 shipped; at or above
// this the Inventory screens may lay out as a two-column workbench.
//
// 1180 is not a round number chosen for looks. The workbench is a 236px action
// rail, a 14px gutter and an 850px table -- below 850 the table's six columns
// start truncating the item name, which is the one column that cannot be read at
// a glance if it is clipped. 236 + 14 + 850 = DESKTOP_COLUMN, and a laptop at
// 1024 gets the bounded column rather than a squeezed workbench. That is gate
// decision W2.
export const WORKBENCH_BREAKPOINT = 1180;
